module.exports = __webpack_public_path__ + "static/img/dev_p4.d9120a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/developerCommunity/dev_p4.png
// module id = PPoh
// module chunks = 2